<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="typeName"
                  label="BinType Name"
                  v-model="bintype.typeName"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="typeCode"
                  label="BinType Code"
                  v-model="bintype.typeCode"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="BinType Description"
                  v-model="bintype.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="bintype.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="bintype.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="bintype.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="bintype.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="bintype.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="bintype.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="user.roleName === 'PRODUCTION_MANAGER'" >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn 
                  color="primary" 
                  :loading="saveLoading" 
                  :disabled="!valid || user.roleName === 'PRODUCTION_MANAGER'" 
                  type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { binTypeService } from "../../services/bintype-service";
import { BinType } from "../../models/model";
import { BinTypeFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
export default {
  name: "BinTypeDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "BinType",
        disabled: false,
        to: "bintypes"
      },
      {
        text: "BinType Detail",
        disabled: true
      }
    ],
    updatedDate: "",
    createdDate: "",
    bintype: new BinType(),
    oldBintype: new BinType(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new BinTypeFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new brand
    } else {
      this.getBinTypeDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        let bintypeObj = {
          id: this.bintype.id ? this.bintype.id : "",
          typeName: this.bintype.typeName,
          typeCode: this.bintype.typeCode,
          description: this.bintype.description
        };
        binTypeService
          .saveBinType(bintypeObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getBinTypeDetail(id) {
      binTypeService
        .getBinTypeDetail(id)
        .then(res => {
          this.bintype = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.bintype.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.bintype.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldBintype = Object.assign({}, res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.bintype.id) {
        this.bintype = new BinType();
      } else {
        this.bintype = Object.assign({}, this.oldBintype);
      }
    },
    goBack() {
      this.$router.push("/bintypes");
    }
  }
};
</script>
